export const actionTypes = {
    CHAGE: 'CHANGE_LOADING'
}

export const changeLoading = (payLoad) =>({
    type: actionTypes.CHAGE,
    payLoad
})